/*************************************************/
/* LANGUAGE                                      */
/*************************************************/

export function language() {
    let languageSelector;

    const init = function () {
        languageSelector = $('.language-selector');

        languageSelector.find('.language-selector__current').on('click', function () {
            $(this).next('.language-selector__list').toggle();
        });
    };

    init();
}

